import { useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FinancialAccount } from "@/types";

type Props = {
  financial_account?: FinancialAccount;
};

export function FinancialAccountForm({ financial_account }: Props) {
  const { data, setData, post, patch, processing, errors, transform } = useForm(
    {
      name: financial_account?.name || "",
    },
  );

  transform((data) => {
    return { financial_account: data };
  });

  function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();

    if (financial_account) {
      patch(`/financial_accounts/${financial_account.id}`, {
        preserveScroll: "errors",
      });
    } else {
      post("/financial_accounts", {
        preserveScroll: "errors",
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="financial_account_name">Name</Label>
        <Input
          id="financial_account_name"
          name="name"
          value={data.name}
          onChange={(e) => setData("name", e.target.value)}
          aria-invalid={!!errors.name}
        />
        {errors.name && (
          <p className="text-sm text-destructive">{errors.name}</p>
        )}
      </div>
      <div className="flex justify-end">
        <Button type="submit" disabled={processing}>
          {financial_account
            ? "Update financial account"
            : "Create financial account"}
        </Button>
      </div>
    </form>
  );
}
